import { Component, OnInit } from '@angular/core';

@Component({
    selector: '[list-table-column]',
    templateUrl: 'list-table-column.component.html',
    styleUrls: [ 'list-table-column.component.scss' ]
})
export class ListTableColumnComponent implements OnInit {

    ngOnInit(): void {
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/abstract-plugins/list/components/list-table-column/list-table-column.component.ts